<template>
  <my-dialog
    @hideMask="$emit('update:classroomObservationDialogFlag', false)"
    :dialogFlag="classroomObservationDialogFlag"
    width="660px"
    p_lr="0"
    borderRadius="8px"
    :hideMaskFlag="false"
    :clickMaskForHide="true"
  >
    <div class="classroom_observation_container">
      <div class="classroom_observation_container_header">
        <h3 class="header_title">课堂观摩设置</h3>
        <div class="close_btn" @click="$emit('update:classroomObservationDialogFlag', false)">
          <img
            src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/322b44f4a1e34d8cb527d1e033ec659b.png"
            alt="关闭"
          />
        </div>
      </div>
      <div class="classroom_observation_container_body">
        <div class="body_item">
          <div class="body_item_title">直播开关</div>
          <div class="body_item_content">
            <a-checkbox v-model:checked="pushRtmp" @change="(e) => handlePushRtmpChange(e)">开启RTMP直播</a-checkbox>
          </div>
        </div>
        <div class="body_item">
          <div class="body_item_title">直播观摩地址</div>
          <div class="body_item_content flex">
            <p class="body_item_content_url" @click="handleObserve">{{ classroomObservationUrl }}</p>
            <span class="copy_btn" @click="handleCopy">复制</span>
          </div>
        </div>
        <div class="body_item">
          <div class="body_item_title">平台推流地址</div>
          <div class="body_item_content flex">
            <a-input v-model:value="rtmpPushUrl" placeholder="请输入平台推流地址" style="width: 360px" />
            <a-popover title="拉流地址" overlayClassName="popover_container" trigger="hover">
              <template slot="content">
                <div class="popover_container_inner">
                  <!-- <p class="popover_item" @click="handleCopyPullUrl(liveDelaySwitch ? pullUrlObj.rtmpDelayPullUrl : pullUrlObj.rtmpPullUrl)">rtmp拉流地址：{{ (liveDelaySwitch ? pullUrlObj.rtmpDelayPullUrl : pullUrlObj.rtmpPullUrl) || '- -' }}</p>
                  <p class="popover_item" @click="handleCopyPullUrl(liveDelaySwitch ? pullUrlObj.flvDelayPullUrl : pullUrlObj.flvPullUrl)">flv拉流地址：{{ (liveDelaySwitch ? pullUrlObj.flvDelayPullUrl : pullUrlObj.flvPullUrl) || '- -' }}</p>
                  <p class="popover_item" @click="handleCopyPullUrl(liveDelaySwitch ? pullUrlObj.hlsDelayPullUrl : pullUrlObj.hlsPullUrl)">hls拉流地址：{{ (liveDelaySwitch ? pullUrlObj.hlsDelayPullUrl : pullUrlObj.hlsPullUrl) || '- -' }}</p> -->
                  <p class="popover_item" @click="handleCopyPullUrl(pullUrlObj.rtmpPullUrl)">
                    rtmp拉流地址：{{ pullUrlObj.rtmpPullUrl || '- -' }}
                  </p>
                  <p class="popover_item" @click="handleCopyPullUrl(pullUrlObj.flvPullUrl)">
                    flv拉流地址：{{ pullUrlObj.flvPullUrl || '- -' }}
                  </p>
                  <p class="popover_item" @click="handleCopyPullUrl(pullUrlObj.hlsPullUrl)">
                    hls拉流地址：{{ pullUrlObj.hlsPullUrl || '- -' }}
                  </p>
                </div>
              </template>
              <span class="copy_btn" @mouseover="handleShowPullUrl">显示拉流地址</span>
            </a-popover>
          </div>
        </div>
        <div class="body_item body_item_flex_start">
          <div class="body_item_title">第三方推流地址</div>
          <div class="body_item_content">
            <a-textarea
              v-model:value="threeCompanyPushUrl"
              placeholder="请输入第三方推流地址，地址间请用;分割"
              :rows="4"
              style="width: 360px; resize: none"
            />
          </div>
        </div>
        <div class="body_item">
          <div class="body_item_title">直播延迟</div>
          <div class="body_item_content flex" style="height: 34px">
            <a-switch
              :default-checked="liveDelaySwitch"
              @change="handleLiveDelayCheckedChange"
              style="margin-right: 16px"
            />
            <template v-if="liveDelaySwitch">
              <a-input v-model:value="liveDelayTime" type="number" placeholder="请输入" style="width: 80px" />
              <span class="second">秒</span>
              <span class="body_item_content_explain">请输入15-3600之间的整数</span>
            </template>
          </div>
        </div>
        <div class="body_item body_item_flex_start">
          <div class="body_item_title">自定义课间展示图片</div>
          <div class="body_item_content">
            <div
              :class="`body_item_content_upload ${imageUrl ? 'has-image' : ''}`"
              :style="`background-image: url('${imageUrl}')`"
            >
              <div class="update-mask">
                <i :class="`icon-upload ${uploadLoading ? 'icon-loading' : ''} `"></i>
                <span class="btn-text">{{ uploadLoading ? '上传中...' : '自定义上传' }}</span>
              </div>
              <div class="update-wrap" :style="`display:${uploadLoading ? 'none' : 'block'}`">
                <UploadImg @updateUpload="updateUpload" />
              </div>
              <div
                style="
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  background-color: rgba(255, 255, 255, 0.1);
                  cursor: not-allowed;
                  z-index: 9999;
                "
              ></div>
            </div>
            <div class="body_item_content_explain">建议尺寸16:9，格式为png/jpg/gif，图片不超过5M。</div>
          </div>
        </div>
      </div>
      <div class="classroom_observation_container_footer">
        <div class="cancel_btn" @click="$emit('update:classroomObservationDialogFlag', false)">取消</div>
        <div class="confirm_btn" @click="handleConfirm">确定</div>
      </div>
      <div class="loading_mask" v-if="loadingFlag">
        <a-spin />
      </div>
    </div>
  </my-dialog>
</template>

<script>
import UploadImg from '../../views/CourseManagement/activity/comp/UploadImg.vue'
export default {
  name: 'classroomObservation',
  components: {
    'my-dialog': () => import('@/components/my_dialog'),
    UploadImg
  },
  data() {
    return {
      pushRtmp: false,
      liveDelayTime: '',
      imageUrl: '',
      uploadLoading: false,
      loadingFlag: false,
      rtmpPushUrl: '',
      threeCompanyPushUrl: '',
      liveDelaySwitch: false,
      pullUrlObj: {}
    }
  },
  props: {
    classroomObservationDialogFlag: {
      type: Boolean,
      default: false
    },
    classroomObservationUrl: {
      type: String,
      default: ''
    },
    cdnViewSettingInfo: {
      type: Object,
      default: {}
    }
  },
  watch: {
    classroomObservationDialogFlag: {
      handler: function (newVal) {
        if (!newVal) {
          this.pushRtmp = this.liveDelaySwitch = this.uploadLoading = false
          this.liveDelayTime = this.imageUrl = this.rtmpPushUrl = this.threeCompanyPushUrl = ''
          return
        }
        if (!Object.keys(this.cdnViewSettingInfo).length) return
        const { pushRtmp, liveDelayTime, image, cdnPushUrl, threeCompanyPushUrl, liveDelaySwitch } =
          this.cdnViewSettingInfo
        this.pushRtmp = pushRtmp || false
        this.liveDelayTime = liveDelayTime || ''
        this.imageUrl = image || ''
        this.rtmpPushUrl = cdnPushUrl || ''
        this.threeCompanyPushUrl = threeCompanyPushUrl || ''
        this.liveDelaySwitch = liveDelaySwitch || false
      }
    }
  },
  methods: {
    handlePushRtmpChange(e) {
      console.log(e.target.checked)
    },
    handleObserve() {
      window.open(this.classroomObservationUrl, '_blank')
    },
    handleCopy() {
      this.$copyText(this.classroomObservationUrl).then(
        () => {
          this.$message.success('复制成功!')
        },
        () => {
          this.$message.error('复制失败!')
        }
      )
    },
    handleCopyPullUrl(url) {
      if (!url) return
      this.$copyText(url).then(
        () => {
          this.$message.success('复制成功!')
        },
        () => {
          this.$message.error('复制失败!')
        }
      )
    },
    updateUpload(obj = {}) {
      this.imageUrl = obj.imageUrl || this.imageUrl
      this.uploadLoading = obj.loading
    },
    isInteger(num) {
      return (num | 0) === num
    },
    async handleConfirm() {
      try {
        const { liveId } = this.$route.query
        if (this.liveDelaySwitch) {
          if (!this.liveDelayTime) return this.$message.error('请输入直播延迟时间')
          if (
            !this.isInteger(Number(this.liveDelayTime)) ||
            Number(this.liveDelayTime) < 15 ||
            Number(this.liveDelayTime) > 3600
          )
            return this.$message.error('请输入15-3600之间的整数')
        }
        this.loadingFlag = true
        const params = {
          liveId,
          pushRtmp: this.pushRtmp,
          liveDelayTime: parseInt(this.liveDelayTime || 0),
          image: this.imageUrl,
          rtmpPushUrl: this.rtmpPushUrl,
          threeCompanyPushUrl: this.threeCompanyPushUrl,
          liveDelaySwitch: this.liveDelaySwitch
        }
        const result = await this.$http.livesettingCdnViewSetting(params)
        if (result.code !== 200) {
          this.loadingFlag = false
          return this.$message.error(result.msg || '抱歉，设置失败')
        }
        let { rt: resultReally } = result
        if (resultReally.resultStatus !== 1) {
          this.loadingFlag = false
          return this.$message.error(resultReally.resultMessage || '抱歉，设置失败')
        }
        this.loadingFlag = false
        this.$message.success('设置成功')
        this.$emit('getCdnViewSettingInfo')
        this.$emit('update:classroomObservationDialogFlag', false)
        this.pushRtmp = this.liveDelaySwitch = this.uploadLoading = false
        this.liveDelayTime = this.imageUrl = this.rtmpPushUrl = this.threeCompanyPushUrl = ''
      } catch (err) {
        console.log(err)
      }
    },
    async handleShowPullUrl() {
      if (!this.rtmpPushUrl) return
      try {
        const { liveId } = this.$route.query
        const params = {
          liveId,
          cdnPushUrl: this.rtmpPushUrl
        }
        const result = await this.$http.livesettingCdnPullUrlGet(params)
        if (result.code !== 200) return
        this.pullUrlObj = result.rt || {}
      } catch (err) {
        console.log(err)
      }
    },
    handleLiveDelayCheckedChange(checked) {
      this.liveDelaySwitch = checked
      if (checked) this.liveDelayTime = 300
    }
  }
}
</script>

<style lang="scss">
.popover_container {
  .popover_container_inner {
    width: auto;
    height: auto;
    padding: 15px;
    .popover_item {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
        text-decoration-color: #ddd;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@keyframes loadingAni {
  0% {
    transform: rotate(-180deg);
  }
  100% {
    transform: rotate(180deg);
  }
}
.classroom_observation_container {
  position: relative;
  .classroom_observation_container_header {
    width: 100%;
    height: 60px;
    border-radius: 8px 8px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    border-bottom: 2px solid #eaeaea;
    .header_title {
      font-size: 16px;
      font-weight: 500;
      color: #1e2228;
    }
    .close_btn {
      width: 12px;
      height: 12px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .classroom_observation_container_body {
    width: 100%;
    height: auto;
    padding-top: 20px;
    .body_item {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin-bottom: 22px;
      &.body_item_flex_start {
        align-items: flex-start;
      }
      .body_item_title {
        width: 156px;
        font-weight: 600;
        color: #1e2228;
        text-align: right;
        margin-right: 16px;
      }
      .body_item_content {
        &.flex {
          display: flex;
        }
        .body_item_content_url {
          width: 360px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #3982ff;
          cursor: pointer;
        }
        .copy_btn {
          color: #3982ff;
          margin-left: 8px;
          cursor: pointer;
          user-select: none;
          &:hover {
            color: #306fdc;
          }
          &:active {
            color: #3982ff;
          }
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
        input[type='number'] {
          -moz-appearance: textfield;
        }
        .second {
          margin: 0 8px;
        }
        .body_item_content_explain {
          font-size: 12px;
          color: #9fa2b1;
        }
        .body_item_content_upload {
          width: 160px;
          height: 90px;
          position: relative;
          border-radius: 2px;
          border: 1px solid #dcdee0;
          background: #f6f8fa;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center center;
          margin-bottom: 8px;
          .update-mask {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            line-height: 30px;
            .icon-upload {
              display: inline-block;
              width: 24px;
              height: 24px;
              background: url('../../assets/img/icon-plus2@2x.png') no-repeat;
              background-size: cover;
              &.icon-loading {
                background: none;
                border: 2px solid #969799;
                border-left: 2px solid transparent;
                border-radius: 100%;
                animation: loadingAni infinite 1s linear;
              }
            }
            .btn-text {
              color: #969799;
              margin: 0;
            }
          }
          .update-wrap {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            cursor: pointer;
            z-index: 1;
          }
          &.has-image {
            .update-mask {
              background-color: rgba(0, 0, 0, 0.5);
            }
            .btn-text {
              color: #fff;
            }
            .icon-upload {
              background-image: url('../../assets/img/icon-plus3@2x.png');
              &.icon-loading {
                border: 2px solid #fff;
                border-left: 2px solid transparent;
              }
            }
          }
        }
      }
    }
  }
  .classroom_observation_container_footer {
    width: 100%;
    height: auto;
    padding: 20px 0;
    border-top: 2px solid #eaeaea;
    display: flex;
    justify-content: center;
    .cancel_btn,
    .confirm_btn {
      width: 104px;
      height: 38px;
      border-radius: 4px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
    }
    .cancel_btn {
      border: 1px solid #5f60d3;
      color: #5f60d3;
      margin-right: 16px;
      &:hover {
        background-color: #f5f5f5;
      }
      &:active {
        background-color: #fff;
      }
    }
    .confirm_btn {
      background-color: #5f60d3;
      color: #fff;
      &:hover {
        background-color: #4b4dbf;
      }
      &:active {
        background-color: #5f60d3;
      }
    }
  }
  .loading_mask {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.7);
    cursor: not-allowed;
  }
}
</style>
